import { render, staticRenderFns } from "./growthSales.vue?vue&type=template&id=368add1a&scoped=true"
import script from "./growthSales.vue?vue&type=script&lang=js"
export * from "./growthSales.vue?vue&type=script&lang=js"
import style0 from "./growthSales.vue?vue&type=style&index=0&id=368add1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368add1a",
  null
  
)

export default component.exports